import { useMySkillMapQuery } from 'core/graphql';

import { ISkillMap, transformSkillMap } from './transform';

/**
 * ТЗ 0039 шаг 5 — карта навыков.
 *
 * Отдельный запрос, а не поле внутри `myGrowth`: панель карты открывается по
 * `?tab=skills`, и грузить её данные тому, кто смотрит только трек, незачем.
 */
export const useSkillMap = (skip = false) => {
  const { data, loading } = useMySkillMapQuery({
    skip,
    fetchPolicy: 'cache-and-network',
  });

  return {
    skillMap: transformSkillMap(data?.mySkillMap) as ISkillMap | null,
    loading,
  };
};
